<template>
  <section class="main-container">
    <div class="zcontainer">
      <h3 class="title">{{ user.name }}</h3>      
      
      <div class="columns mt-3 is-multiline">
        <div class="column is-one-quarter" v-if="user.city">          
          <p class="label" > Població </p>
          <p class="desc">{{ user.city }}</p>
          <p class="desc mb-1">{{ user.territorial | territorialDescription }}</p>
        </div>        
        <div class="column is-one-quarter" v-if="user.phone">
          <label class="label" > Telèfon </label>
          <p class="desc mb-1">{{ user.phone }}</p>
        </div>
        <div class="column is-one-quarter" v-if="user.web">
          <label class="label" > Web </label>
          <p class="desc mb-1">{{ user.web }}</p>
        </div>
        <div class="column is-one-quarter" v-if="user.contactEmail">
          <label class="label" > Correu </label>
          <p class="desc mb-1">{{ user.contactEmail }}</p>
        </div>
        <div class="column is-full">
          <label class="label" v-if="user.contact"> Contacte </label>
          <p class="desc mb-1" style="white-space: pre-line;">{{ user.contact }}</p>
        </div>
        <div class="column is-full">
          <label class="label" v-if="user.description"> Descripció </label>
          <p class="desc" style="white-space: pre-line;">{{ user.description }}</p>
        </div>            
      </div>

      <h4 class="title is-spaced mt-3">Les iniciatives de {{ user.name }}</h4>
      <div class="columns is-multiline is-desktop">
        <div class="column is-one-third" v-for="box in userBoxes" v-bind:key="box.id">
          <BoxItemDetail :box="box"></BoxItemDetail>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");
import BoxItemDetail from '@/components/BoxItemDetail'
import { territorialDescription } from '../services/descriptions.filters';

export default {
  components: {
    BoxItemDetail
  },
  data() {
    return {
      showSuccess: false,
      userId: "",
      user: {},
      userBoxes: []
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  mounted() {
    
    if (this.$route.params.id) {
      this.userId = this.$route.params.id;
      this.viewUser();
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      //console.log("to", to, from);
      if (this.$route.params.id) {
        this.userId = this.$route.params.id;
        this.viewUser();
      }
    }
  },
  created() {},
  methods: {
    viewUser() {
      fb.usersCollection
        .doc(this.userId)
        .get()
        .then(doc => {
          if (doc.exists) {
            let user = doc.data()
            user.id = doc.id
            this.user = user
            this.getUserBoxes()
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUserBoxes() {

      let states = ['draft', 'new', 'active']
      
      fb.boxesCollection.where("environment", "==", process.env.BOX_ENV).where("userId", "==", this.userId).where('state', 'in', states).orderBy('createdOn', 'desc')
            .onSnapshot(querySnapshot => {
                            
                let userBoxes = []
                querySnapshot.forEach(doc => {
                  console.log('doc', doc)
                    let box = doc.data()
                    box.id = doc.id
                    console.log('box.id', box.id)
                    userBoxes.push(box)
                })

                this.userBoxes = userBoxes

                //commit('setUserBoxes', userBoxes)            

            });
    }
  }
};
</script>
<style scoped>
.mt-3{
  margin-top: 3rem;
}
p.desc{
  font-size: 16px;
  color: #a3a3a3;
  line-height: 30px;
}
.table td{
  text-align: center;
}
.mb-1{
  margin-bottom: 1rem;
}
.label{
  color: #363636;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue